import { ComponentDetails } from "./componentDetails";
import { InputParameter } from "./inputParameters.model";
import { OutputParameter } from "./outputParameters.model";
import { formulaList } from "./formulaList";


export class PlatformComponent {
  componentUniqueId: string;
  componentId: number;
  componentName: string;
  componentImage: string;
  componentType: string;
  componentDetails: ComponentDetails;
  inputParameters: InputParameter[];
  outputParameters: OutputParameter[];
  isBranchingTrue: any[];
  isBranchingFalse: any[];
  srcComponent: string[];
  sinkComponent: string[];
  formulaList: formulaList[];

  constructor() {
    this.componentUniqueId = '00';
    this.componentId = 0;
    this.componentName = '';
    this.componentImage = null;
    this.componentType = '';
    this.componentDetails = new ComponentDetails();
    this.inputParameters = [];
    this.outputParameters = [];
    this.isBranchingTrue = [];
    this.isBranchingFalse = [];
    this.srcComponent = [];
    this.sinkComponent = [];
    this.formulaList = [];
  }
}
